module.exports = __webpack_public_path__ + "src/img/static.9e0b983e.svg";